import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePostQuery } from 'hooks'
import { Box, Button, Card, FormInput, Title } from 'components'

export const AdminUserNew = () => {
  const navigate = useNavigate()
  const { post: createUser } = usePostQuery({ url: '/admin/users' })
  const [state, setState] = useState({
    email: '',
    password: '',
    password_confirmation: '',
    full_name: '',
    username: ''
  })
  const [error, setError] = useState(null)

  const handler = ({ target: { name, value } }) => {
    setState(prev => ({ ...prev, [name]: value }))
    setError(null)
  }

  const submit = async () => {
    if (!state.email || !state.password) {
      setError('Email and password are required')
      return
    }
    if (state.password !== state.password_confirmation) {
      setError("Passwords don't match")
      return
    }
    const res = await createUser(state)
    if (res?.user?.slug) {
      navigate(`/admin/users/${res.user.slug}`)
    } else {
      setError('Failed to create user')
    }
  }

  return (
    <Card margin="0.5rem">
      <Title level={3} color="link">New User</Title>
      <FormInput
        label="Email"
        name="email"
        type="email"
        onChange={handler}
        value={state.email}
        required
      />
      <FormInput
        label="Full Name"
        name="full_name"
        onChange={handler}
        value={state.full_name}
      />
      <FormInput
        label="Username"
        name="username"
        onChange={handler}
        value={state.username}
      />
      <FormInput
        label="Password"
        name="password"
        type="password"
        onChange={handler}
        value={state.password}
        required
      />
      <FormInput
        label="Confirm Password"
        name="password_confirmation"
        type="password"
        onChange={handler}
        value={state.password_confirmation}
        required
      />
      {error && <Box margin="0.5rem" color="error">{error}</Box>}
      <Button onPress={submit}>Create User</Button>
    </Card>
  )
}
